module.exports = __webpack_public_path__ + "static/media/chilecompra.09757b9a.jpg";